export default __webpack_public_path__ + "static/media/POPPINS-ITALIC.87fa2a34.TTF";